import type { LocationType, Nullable } from '~/core/types'
import { MatchLevel } from '~/core/types'

type Position = { coords: { latitude: number, longitude: number } }

export const capitalize = (str: LocationType) => str.charAt(0).toUpperCase() + str.slice(1)

export const currentLocation = async (isMobile: boolean, options?: { timeout: number }): Promise<Nullable<Position | GeolocationPosition>> => {
  if (import.meta.server) {
    return null
  }

  if (isMobile) {
    const { Geolocation } = await import('@capacitor/geolocation')
    return await Geolocation.getCurrentPosition(options)
  }

  if (!navigator.geolocation) {
    console.warn('Geolocation is not supported by this browser')
    return null
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  })
}

export async function checkPermission(isMobile: boolean) {
  if (import.meta.server) {
    return null
  }
  if (isMobile) {
    const { Geolocation } = await import('@capacitor/geolocation')
    const permission = await Geolocation.checkPermissions()
    return permission.location
  }

  if (!navigator.geolocation) {
    console.warn('Geolocation is not supported by this browser')
    return null
  }
  if (navigator.permissions && navigator.permissions.query) {
    return await navigator.permissions.query({ name: 'geolocation' })
  }
  return null
}

export const highlightResults = (value: string, searchValue: Nullable<string>) => {
  const regex = new RegExp(`(${searchValue})`, 'gi')
  return {
    fullyHighlighted: value.toLocaleLowerCase() === searchValue?.toLocaleLowerCase(),
    matchLevel: value.match(regex) ? MatchLevel.FULL : MatchLevel.NONE,
    matchedWords: value.match(regex),
    value: value.replace(regex, `<em>$&</em>`),
  }
}
